import { Base } from '../core/base.model';
import { EstatusTareaEnum } from 'src/app/utilerias/enums/estatusTareaDiariaEnum';
import { TiempoTarea } from './tiempoTarea.model';

export class TareaDiaria extends Base {
    id: number;
    nombre: string;
    descripcion: string;

    estatus: EstatusTareaEnum;
    idProyecto: string;
    /** Solo lectura: lo trae consultaTareaHistorial.do aunque el proyecto ya esté cerrado o el usuario liberado. */
    nombreProyecto: string;
    idAreaSolicitante: number;
    idAreaResolutora: number;
    idUsuario: number;
    idCliente: number;
    idArea: number;
    terminada: boolean;

    tiempo_total:number;
    tiempo_total_text: string;
    motivoRegistro: string;
    beanAlterno: any;

    

    fechaCreacionStr: string;

    fecha_creacion: Date;
    fecha_inicio: Date;
    fecha_inicio_str: string;
    fecha_fin: Date;
    fecha_fin_str: string;
    tiempoTarea: Array<TiempoTarea>;

    tiempoTotalInvertido: number;
    tiempoTotalInvertidoStr: string;
    tiempoTotalInvertidoXDia: number;
    tiempoTotalInvertidoXDiaStr: string;

    evidencias: any[];
    historial: any [];

    band: boolean = false;
}

export class TareaDiariaEvidencia{
    id: number;
    id_tarea : number;
    nombreArchivo: string;
    name: string;
}
